
import { JobForm } from '@cms/components/forms/JobForm'
import { renderAttribute } from '@cms/components/renders'
import { generateSearchParam, renderDateTime } from '@cms/utils/helpers'
import { COMMON_RESOURCES, ISystemJob } from '@dl/declarations'
import clsx from 'clsx'
import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { DataPart } from '../../components/ui/DataPart'
import PageContainer from '../../components/ui/PageContainer'
import { JobsPath, renderRouteOptions, Routes } from '../../utils/routes'

const JobsPage = () => {

    const renderItem = useCallback((item: ISystemJob) => {
        return (
            <Link
                className={clsx(
                    'py-4 ps-4 pe-12 w-full',
                    'flex flex-col items-start gap-2',
                    'border border-cs-700 rounded-md',
                )}
                to={{
                    pathname: Routes.JOBS,
                    search: `?${generateSearchParam(JobsPath, "mode", "update")}&${generateSearchParam(JobsPath, "id", item._id)}`,
                }}
                key={item._id}
            >
                <h4 className='w-full text-cs-600 font-semibold'>{item.role}</h4>

                <div className='w-full grid grid-cols-4 items-center gap-20'>
                    {renderAttribute({
                        title: { value: 'Status' },
                        value: { value: [item.is_active ? 'Activated' : 'Inactive'], className: 'text-cs-500' }
                    })}

                    {renderAttribute({
                        title: { value: 'Published' },
                        value: {
                            value: [renderDateTime(item.created_at)],
                            component: (
                                renderDateTime(item.created_at)
                            )
                        }
                    })}

                    {renderAttribute({
                        title: { value: 'Last modified' },
                        value: {
                            value: [renderDateTime(item.updated_at)],
                            component: (
                                renderDateTime(item.updated_at)
                            )
                        }
                    })}
                </div>
            </Link>
        )
    }, [])

    return (
        <PageContainer
            title={renderRouteOptions(Routes.JOBS).title}
        >
            <DataPart<ISystemJob>
                tableSize='full'

                distribution={{
                    type: 'grid',
                    noOfColumns: "1",
                    renderItem: renderItem
                }}

                queryOptions={{
                    basePath: COMMON_RESOURCES.JOBS.ROUTE
                }}

                updateOptions={{
                    allow: true,
                    hide: true
                }}
                createOptions={{
                    allow: true
                }}
                searchOptions={{
                    allow: true
                }}

                form={<JobForm />}
            />
        </PageContainer>
    )
}

export default JobsPage